import gql from 'graphql-tag';

export default gql`
  query ordersPrintAll($input: OrderFilterInput, $regionCodes: [String]) {
    ordersPrintAll(input: $input, regionCodes: $regionCodes)
  }
`;
